import axios from "axios";

const getAppointmentHoursByDayIdAndRoomId = async (baseUrl, token, doctorId, dayValue, clinicId, roomId) => {
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let getResponse = null

    await axios.get(baseUrl + "/doctor/" + doctorId + "/appointment/hours/" + dayValue + "/clinic/" + clinicId + "/room/" + roomId, config)
        .then((res) => {
            getResponse = {
                status: res.status,
                data: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                getResponse = {
                    status: error.response.status,
                    data:  error.response.status
                }
            }
        });
    return getResponse
}

export default getAppointmentHoursByDayIdAndRoomId;